import { useContext } from 'react';
import { Box, Typography } from '@mui/material';
import { ReportTemplatesContext } from '..';
import { RemoveBlockSVG } from './HelperSVGs';

export function NationalAverageCrimeIndex({ title, sectionKey }) {
  const { removeBlock } = useContext(ReportTemplatesContext);
  return (
    <Box
      sx={{
        flex: 1,
        backgroundColor: '#F9F9F9',
        paddingY: '1.25rem',
        paddingX: '1rem',
        borderRadius: '1rem',
        display: 'flex',
        gap: '1rem',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Typography
        sx={{
          fontFamily: 'Lato',
          lineHeight: '1.5rem',
          textAlign: 'center',
          fontSize: '1.4rem',
          fontWeight: 900,
        }}
      >
        2.25x
      </Typography>

      <Typography
        sx={{
          fontFamily: 'Lato',
          lineHeight: '1.5rem',
          textAlign: 'center',
          fontSize: '1rem',
          fontWeight: 500,
        }}
      >
        National Average
      </Typography>
      <Typography
        sx={{
          fontFamily: 'Lato',
          lineHeight: '1.5rem',
          textAlign: 'center',
          fontSize: '1.1rem',
          fontWeight: 500,
          color: '#39585C',
        }}
      >
        {title}
      </Typography>
      <Box
        sx={{
          cursor: 'pointer',
          alignSelf: 'center',
        }}
        onClick={() => {
          removeBlock(title, sectionKey);
        }}
      >
        <RemoveBlockSVG />
      </Box>
    </Box>
  );
}
